import React from 'react';
export function PricingSection() {
  const handleBuyClick = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
        content_type: 'product',
        value: 14990,
        currency: 'CLP'
      });
    }
  };
  return <section id="pricing" className="py-12 md:py-16 text-center text-white relative overflow-hidden" style={{
    background: 'var(--ink)'
  }} data-id="element-186">
      {/* Radial gradient overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 70% 55% at 50% 0%, rgba(200,169,110,.1) 0%, transparent 60%)'
    }} data-id="element-187" />

      <div className="relative max-w-[960px] mx-auto px-5" data-id="element-188">
        <p className="text-[10px] tracking-[4px] uppercase mb-3" style={{
        color: 'var(--gold)'
      }} data-id="element-189">
          La oferta completa
        </p>

        <h2 className="font-serif font-normal max-w-[640px] mx-auto mb-2" style={{
        fontSize: 'clamp(26px, 5vw, 48px)'
      }} data-id="element-190">
          Todo lo que necesitás para cerrar,
          <br data-id="element-191" />
          <em style={{
          color: 'var(--gold-light)',
          fontStyle: 'italic'
        }} data-id="element-192">
            en un solo kit
          </em>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center mt-8 md:mt-10" data-id="element-193">
          {/* Bundle Image */}
          <div className="fade-in text-center" data-id="element-194">
            <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BUNDLE.png?v=1772835860" alt="Bundle completo Kit Digital 33 Rituales" className="w-full max-w-[320px] md:max-w-[400px] mx-auto float-animation" style={{
            filter: 'drop-shadow(0 24px 56px rgba(200,169,110,.3))'
          }} data-id="element-195" />
          </div>

          {/* Pricing Box */}
          <div className="fade-in rounded-2xl p-6 md:p-8 text-left relative" style={{
          background: 'rgba(255,255,255,.05)',
          border: '1px solid rgba(200,169,110,.25)'
        }} data-id="element-196">
            {/* Badge */}
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 text-[10px] font-medium tracking-[2.5px] uppercase py-[6px] px-5 rounded-full whitespace-nowrap" style={{
            background: 'linear-gradient(135deg, var(--gold), var(--gold-shine))',
            color: 'var(--ink)'
          }} data-id="element-197">
              ✦ Oferta especial 3×1
            </div>

            {/* Price Items */}
            <ul className="list-none mb-5 mt-2" data-id="element-198">
              <li className="flex justify-between items-center py-3 text-[13px] gap-2" style={{
              borderBottom: '1px solid rgba(255,255,255,.07)',
              color: 'rgba(255,255,255,.7)'
            }} data-id="element-199">
                <span className="flex-1" data-id="element-200">
                  📖 33 Rituales para Soltar el Pasado
                </span>
                <span className="line-through opacity-40 text-[11px] flex-shrink-0" data-id="element-201">
                  $34.990
                </span>
                <span className="font-medium flex-shrink-0" style={{
                color: 'var(--gold-light)'
              }} data-id="element-202">
                  $14.990
                </span>
              </li>
              <li className="flex justify-between items-center py-3 text-[13px] gap-2" style={{
              borderBottom: '1px solid rgba(255,255,255,.07)',
              color: 'rgba(255,255,255,.7)'
            }} data-id="element-203">
                <span className="flex-1" data-id="element-204">
                  📔 Diario Terapéutico de Liberación Emocional
                </span>
                <span className="line-through opacity-40 text-[11px] flex-shrink-0" data-id="element-205">
                  $11.990
                </span>
                <span className="italic text-[12px] flex-shrink-0" style={{
                color: '#a8d8b0'
              }} data-id="element-206">
                  Gratis
                </span>
              </li>
              <li className="flex justify-between items-center py-3 text-[13px] gap-2" style={{
              borderBottom: '1px solid rgba(255,255,255,.07)',
              color: 'rgba(255,255,255,.7)'
            }} data-id="element-207">
                <span className="flex-1" data-id="element-208">
                  🌙 7 Rituales de Emergencia Emocional
                </span>
                <span className="line-through opacity-40 text-[11px] flex-shrink-0" data-id="element-209">
                  $9.990
                </span>
                <span className="italic text-[12px] flex-shrink-0" style={{
                color: '#a8d8b0'
              }} data-id="element-210">
                  Gratis
                </span>
              </li>
            </ul>

            {/* Total Section */}
            <div className="rounded-xl p-5 md:p-6 text-center mb-5" style={{
            background: 'rgba(200,169,110,.1)',
            border: '1px solid rgba(200,169,110,.25)'
          }} data-id="element-211">
              <p className="text-[13px] line-through mb-1" style={{
              color: 'rgba(255,255,255,.4)'
            }} data-id="element-212">
                Valor real del kit completo: $56.970
              </p>
              <p className="font-serif font-bold leading-none mb-1" style={{
              fontSize: 'clamp(48px, 8vw, 68px)',
              color: 'var(--gold-light)'
            }} data-id="element-213">
                $14.990
              </p>
              <span className="inline-block text-[10px] font-medium tracking-[1.5px] uppercase py-[5px] px-3 rounded-full" style={{
              background: 'var(--rose-deep)',
              color: '#fff'
            }} data-id="element-214">
                Ahorrás $41.980 · 73% descuento
              </span>
            </div>

            {/* CTA Button */}
            <a id="pricing-cta" href="https://ebookpromax.com/cart/46586630013086:1" onClick={handleBuyClick} className="block w-full text-center font-sans font-medium text-[12px] tracking-[2.5px] uppercase py-4 px-8 rounded no-underline relative overflow-hidden transition-all duration-300 hover:-translate-y-[3px]" style={{
            background: 'linear-gradient(135deg, var(--gold), var(--gold-shine), var(--gold))',
            backgroundSize: '200% 100%',
            color: 'var(--ink)',
            boxShadow: '0 6px 28px rgba(200,169,110,.4)'
          }} data-id="element-215">
              <span className="relative z-10" data-id="element-216">Quiero mi kit ahora </span>
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,.3), transparent 60%)'
            }} data-id="element-217" />
            </a>

            <p className="text-[11px] tracking-[0.5px] mt-3 text-center" style={{
            color: 'rgba(255,255,255,.45)'
          }} data-id="element-218">
              🔒 Acceso inmediato · PDF descargable · Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}